module.exports = __webpack_public_path__ + "img/nosepick_ios_802.png";